
const SKILLS = {
  might: [
    { id: "athletics", name: "Athletics", desc: "Scale heights, swim, and complete other physical tasks." },
    { id: "block", name: "Block", desc: "Use a weapon or shield to defend against physical attacks." },
    { id: "brawl", name: "Brawl", desc: "Proficiency with hand-to-hand combat." },
    { id: "constitution", name: "Constitution", desc: "Resist detrimental physical effects (alcohol, fatigue, pain)." },
    { id: "craft", name: "Craft", desc: "Create and maintain weapons, armor, and other items." },
    { id: "intimidate", name: "Intimidate", desc: "Affect how a target performs Actions." },
    { id: "large_weapons", name: "Large Weapons", desc: "Proficiency with large weapons." },
    { id: "recover", name: "Recover", desc: "Chance of avoiding hazardous consequences." },
  ],
  speed: [
    { id: "balance", name: "Balance", desc: "Less likely to trip, fall, or slip; better at jumping." },
    { id: "dodge", name: "Dodge", desc: "Evasion. Successful dodge mitigates any damage." },
    { id: "escape", name: "Escape", desc: "Increases chance to escape entrapment or containment." },
    { id: "initiative", name: "Initiative", desc: "Determines order of actions in an encounter." },
    { id: "ranged", name: "Ranged", desc: "Increases proficiency with projectiles." },
    { id: "sleight_of_hand", name: "Sleight of Hand", desc: "Perform dextrous actions." },
    { id: "small_weapons", name: "Small Weapons", desc: "Increases proficiency with small weapons." },
    { id: "sneak", name: "Sneak", desc: "Ability to avoid detection." },
  ],
  intellect: [
    { id: "identify", name: "Identify", desc: "Determine the names and natures of things." },
    { id: "inspiration", name: "Inspiration", desc: "Affect how a target takes Actions." },
    { id: "intuition", name: "Intuition", desc: "Sense motive, gather information, and sense danger." },
    { id: "knowledge", name: "Knowledge", desc: "Application and remembrance of information obtained." },
    { id: "magic_reflex", name: "Magic Reflex", desc: "Defense against magical forces." },
    { id: "perception", name: "Perception", desc: "Increases understanding and awareness of the environment." },
    { id: "persuasion", name: "Persuasion", desc: "Effectively influence a target's decisions or beliefs." },
    { id: "tech", name: "Tech", desc: "Operating and maintaining complex mechanisms." },
  ],
};

export default SKILLS
